import {Container, Graphics} from "pixi.js";
import {EllipseOffset} from "./types";
import {BasicShapes} from "./types";
import { isNil } from 'lodash-es'

const NS = 'PixiShapes';

class PixiShapes {

  drawShape(
    x: number, y:number, w: number, h: number,
    bgClr:number,
    shape: BasicShapes,
    ellipseOffset?: EllipseOffset,
    componentLabel?: string,
    container?: Container,
    itemManipulation?: (item: Graphics) => void
  ): Graphics {
    const item = new Graphics();
    item.label = componentLabel || NS;

    if (itemManipulation) {
      itemManipulation(item);
    }

    switch (shape) {
      case BasicShapes.rect:
        item.rect(x,y,w,h || w);
        break;

      case BasicShapes.roundedRect:
        item.roundRect(x,y,w,h,8);
        break;

      case BasicShapes.ellipse:
        this.drawEllipse(item, x, y, w, h, ellipseOffset);
        break;
    }
    if (!isNil(bgClr)) {
      item.fill(bgClr);
    }

    if (container) {
      container.addChild(item);
    }

    return item;
  }
  drawDotLineShape(x: number, y:number, w: number, h: number,
                   strokeW: number,
                   bgClr:number,
                   shape: BasicShapes,
                   ellipseOffset?: EllipseOffset,
                   componentLabel?: string){
    const item = this.drawShape(x, y, w, h, bgClr, shape, ellipseOffset, componentLabel);
    const mask = new Graphics();
    this.drawDottedMask(mask, w, h, 8, 3.25);
    mask.stroke({
      width: strokeW,
      color: 0xFF00FF
    });
    mask.x = x;
    mask.y = y;
    mask.label = `${componentLabel}-mask`;
    item.addChild(mask);
    // container.addChild(mask);
    item.mask = mask;
    return item;
  }
  drawDottedMask1(graphics: Graphics, width: number, height: number, segmentLength: number, gapLength: number) {
    const widthCount = Math.floor(width / (segmentLength + gapLength)) + 2;
    const heightCount = Math.floor(height / (segmentLength + gapLength)) + 2;
    // horizontal mask
    for (let i = 0; i < heightCount; i++) {
      let x1, y1, x2;
      x1 = -2;
      x2 = width + 3
      y1 = i * (segmentLength + gapLength);
      graphics.moveTo(x1, y1);
      graphics.lineTo(x2, y1);
    }
    // vertical mask
    for (let i = 0; i < widthCount; i++) {
      let x1, y1, y2;
      y1 = -2;
      y2 = height + 3
      x1 = i * (segmentLength + gapLength);
      graphics.moveTo(x1, y1);
      graphics.lineTo(x1, y2);
    }
  }
  drawDottedMask(graphics: Graphics, width: number, height: number, segmentLength: number, gapLength: number) {
    const totalLength = 2 * (width + height);
    const segmentCount = Math.floor(totalLength / (segmentLength + gapLength));
    let currentLength = 0;

    for (let i = 0; i < segmentCount; i++) {
      let x1, y1, x2, y2;

      if (currentLength < width) {
        // Top edge
        x1 = currentLength;
        y1 = 0;
        x2 = Math.min(currentLength + segmentLength, width);
        y2 = 0;
      } else if (currentLength < width + height) {
        // Right edge
        x1 = width;
        y1 = currentLength - width;
        x2 = width;
        y2 = Math.min(currentLength - width + segmentLength, height);
      } else if (currentLength < 2 * width + height) {
        // Bottom edge
        x1 = width - (currentLength - width - height);
        y1 = height;
        x2 = Math.max(width - (currentLength - width - height + segmentLength), 0);
        y2 = height;
      } else {
        // Left edge
        x1 = 0;
        y1 = height - (currentLength - 2 * width - height);
        x2 = 0;
        y2 = Math.max(height - (currentLength - 2 * width - height + segmentLength), 0);
      }

      graphics.moveTo(x1, y1);
      graphics.lineTo(x2, y2);

      currentLength += segmentLength + gapLength;
    }
  }
  // includes custom radii
  drawRectRounded(//graphics: Graphics,
    dimensions: {x: number, y: number, w: number, h: number},
    radius: {topLeft: number, topRight: number, botRight: number, botLeft: number},
    fill: number
  ) {
    const {x,y,w,h} = dimensions;
    const {topLeft, topRight, botRight, botLeft} = radius;

    const bg = new Graphics()
      .moveTo(x + topLeft, y)
      .lineTo(x + w - topRight, y)
      .quadraticCurveTo(x + w, y, x + w, y + topRight)
      .lineTo(x + w, y + h - botRight)
      .quadraticCurveTo(x + w, y + h, x + w - botRight, y + h)
      .lineTo(x + botLeft, y + h)
      .quadraticCurveTo(x, y + h, x, y + h - botLeft)
      .lineTo(x, y + topLeft)
      .quadraticCurveTo(x, y, x + topLeft, y)
      .closePath()
      .fill(fill);

    return bg;

    // Starting from the top left corner.
    // graphics.moveTo(x + topLeft, y)
    //
    // // Drawing the top line with top right corner.
    // graphics.lineTo(x + w - topRight, y)
    // graphics.quadraticCurveTo(x + w, y, x + w, y + topRight)
    //
    // // Drawing the right line with bottom right corner.
    // graphics.lineTo(x + w, y + h - botRight)
    // graphics.quadraticCurveTo(x + w, y + h, x + w - botRight, y + h)
    //
    // // Drawing the bottom line with bottom left corner.
    // graphics.lineTo(x + botLeft, y + h)
    // graphics.quadraticCurveTo(x, y + h, x, y + h - botLeft)
    //
    // // Drawing the left line with top left corner and closing the shape.
    // graphics.lineTo(x, y + topLeft)
    // graphics.quadraticCurveTo(x, y, x + topLeft, y)
    //
    // // Since this shape will likely be filled, closePath ensures that the shape is fully closed.
    // graphics.closePath()
  }

  private drawEllipse(
    el:Graphics, xPos: number, yPos: number, width: number, height: number, ellipseOffset = EllipseOffset.toEdgeRaw
  ) {
    const w = width / 2;
    const h = height ? height /2 : w;
    const x = this.getRoundedValue(xPos + w, ellipseOffset);
    const y = this.getRoundedValue(yPos + h, ellipseOffset);

    height
      ? el.ellipse(x, y, w, h)
      : el.circle(x, y, w);
  }

  private getRoundedValue(val: number, ellipseOffset: EllipseOffset): number {
    switch (ellipseOffset) {
      case EllipseOffset.toEdgeRounded:
        return Math.round(val);

      case EllipseOffset.toEdgeCeil:
        return Math.ceil(val);

      case EllipseOffset.toEdgeFloor:
        return Math.floor(val);
    }

    return val; // EllipseOffset.toEdgeRaw
  }

}

const instance = new PixiShapes();
export default instance as PixiShapes;
